import { render, staticRenderFns } from "./SoliTeacherCert.vue?vue&type=template&id=690a9061&scoped=true"
import script from "./SoliTeacherCert.vue?vue&type=script&lang=js"
export * from "./SoliTeacherCert.vue?vue&type=script&lang=js"
import style0 from "./SoliTeacherCert.vue?vue&type=style&index=0&id=690a9061&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690a9061",
  null
  
)

export default component.exports